export default __webpack_public_path__ + "static/media/upgrade-report9.6b5e8bfa.png";